import { ChangeDetectorRef, Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { DialogService } from '../../../../../services'

const KEY = 'save-filters-dialog'

@Component({
    selector: 'atyl-save-filters-dialog',
    templateUrl: 'save-filters-dialog.component.html',
})
@Stringable({
    path: 'views/partials/layout/dialogs/save-filters-dialog',
    key: KEY,
})
export class SaveFiltersDialog extends BaseDialogComponent {
    @StringableValues(KEY) strings: any
    label: string = '';
    constructor(
        public dialogRef: MatDialogRef<SaveFiltersDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        dialogService: DialogService,
        changeDetectorRef: ChangeDetectorRef
    ) {
        super(dialogRef, dialogService, changeDetectorRef)
    }
}